import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function Header(props) {
    return (
        <div className="jumbotron banner">
            <div className="container">
				{ props.hideImage ? (
						<div style={{ display: 'flex'}}>
							<Typography style={{ fontSize: '24px', fontFamily: 'Space Mono', marginTop: '10px', color: '#fff', lineHeight: '30px', fontWeight: '300', marginRight: '40px'}}>
								Shane<br/>Hipps
							</Typography>
							<Typography style={{ fontSize: '24px',fontFamily: 'Space Mono', marginTop: '10px', color: '#fff', lineHeight: '30px', fontWeight: '300'}}>
								The 7<br/>Management <br/>Polarities&trade;
							</Typography>
						</div>
					) : (
						<img src="/headerlogo_5ll.png" style={{ maxHeight: '75px', marginTop: '20px', verticalAlign: 'middle' }} alt="5 Leadership Languages"></img>
					)
				}
            </div>
        </div>
    );
};
